import React from 'react';

const SocialLinkedinIcon = function SocialLinkedinIcon() {
  return (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="xiQ-Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-27" fillRule="nonzero">
          <circle id="Ellipse_76-Copy-2" fill="#0172B2" cx="18" cy="18" r="18" />
          <g id="linkedin-in" transform="translate(9.000000, 9.000000)" fill="#FFFFFF">
            <path d="M4,18 L0,18 L0,6 L4,6 L4,18 Z M2,4 C0.895705521,4 0,3.08964751 0,1.9905634 C0,0.891205588 0.895430512,0 2,0 C3.10456949,0 4,0.891205588 4,1.9905634 C4,3.08964751 3.10392266,4 2,4 Z M17.9958555,18 L14.1547282,18 L14.1547282,12.3013699 C14.1547282,10.9432485 14.1257167,9.20156556 12.1533467,9.20156556 C10.1519652,9.20156556 9.84527181,10.6771037 9.84527181,12.2035225 L9.84527181,18 L6,18 L6,6.29354207 L9.69192512,6.29354207 L9.69192512,7.89041096 L9.74580369,7.89041096 C10.2597223,6.97064579 11.5150929,6 13.3879948,6 C17.2838295,6 18,8.42270059 18,11.5694716 L18,18 L17.9958555,18 Z" id="Shape" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SocialLinkedinIcon;
